import { Dispatch, SetStateAction } from "react";
import { LoadingOutlined } from "@ant-design/icons";
import { Divider, Spin } from "antd";
import cn from "classnames";
import { TitlePage } from "~/components";
import {
  RulesFiles,
  FormField,
  Wizard,
  UploadFile,
  AcceptPolitics
} from "~/pages/questionnaires/shared";
import { AttachmentsDetailsError, NamesOfFieldEnum } from "~/typings/types";
import { configTitleFieldsOfCompany } from "../configTitleFields";

import "~/pages/questionnaires/shared/styles.css";
import styles from "~/pages/questionnaires/shared/Shared.module.scss";

interface Props {
  isLoadingMount: boolean;
  isLoadingLogo: boolean;
  logoFiles: File[];
  setLogoFileId: Dispatch<SetStateAction<number[]>>;
  setLogoFiles: Dispatch<File[]>;
  logoError: AttachmentsDetailsError;
  setLogoError: Dispatch<AttachmentsDetailsError>;
  COUNT_UPLOAD_LOGO_FILE?: number;
  setIsFirstLoadingFile: Dispatch<boolean>;
  COUNT_DOCUMENT_AGREEMENT1_FILE?: number;
  COUNT_DOCUMENT_AGREEMENT2_FILE?: number;
  isLoadingDocumentAgreement1File: boolean;
  documentAgreement1Files: File[];
  setDocumentAgreement1FileId: Dispatch<SetStateAction<number[]>>;
  setDocumentAgreement1Files: Dispatch<File[]>;
  documentAgreement1Error: AttachmentsDetailsError;
  setDocumentAgreement1Error: Dispatch<AttachmentsDetailsError>;
  isLoadingDocumentAgreement2File: boolean;
  documentAgreement2Files: File[];
  setDocumentAgreement2FileId: Dispatch<SetStateAction<number[]>>;
  setDocumentAgreement2Files: Dispatch<File[]>;
  documentAgreement2Error: AttachmentsDetailsError;
  setDocumentAgreement2Error: Dispatch<AttachmentsDetailsError>;
}

export const AttachmentsDetails = ({
  isLoadingMount,
  isLoadingLogo,
  logoFiles,
  setLogoFileId,
  setLogoFiles,
  logoError,
  setLogoError,
  COUNT_UPLOAD_LOGO_FILE,
  setIsFirstLoadingFile,
  COUNT_DOCUMENT_AGREEMENT1_FILE,
  COUNT_DOCUMENT_AGREEMENT2_FILE,
  isLoadingDocumentAgreement1File,
  documentAgreement1Files,
  setDocumentAgreement1FileId,
  setDocumentAgreement1Files,
  documentAgreement1Error,
  setDocumentAgreement1Error,
  isLoadingDocumentAgreement2File,
  documentAgreement2Files,
  setDocumentAgreement2FileId,
  setDocumentAgreement2Files,
  documentAgreement2Error,
  setDocumentAgreement2Error,
}: Props) => {
  return (
    <Wizard.Page>
      <TitlePage name="Загрузите необходимые документы" number="9" />
      <Divider style={{ margin: 0 }} />
      <div className={cn(styles.container, styles.containerUpload)}>
        {isLoadingMount ? (
          <div className={styles.containerLoader}>
            <Spin indicator={<LoadingOutlined style={{ fontSize: 24, color: "#3d935e" }} spin />} />
          </div>
        ) : (
          <>
            <FormField
              titleField={configTitleFieldsOfCompany[NamesOfFieldEnum.LogoFileId]}
              name={NamesOfFieldEnum.LogoFileId}
              tooltip="Наличие логотипа на платежной странице улучшает визуальное восприятие вашими клиентами страницы и увеличивает конверсию в оплату"
              styleContainer={{ marginBottom: 24, minHeight: 150 }}
              renderError={logoError}
            >
              <div>
                <UploadFile
                  id={NamesOfFieldEnum.LogoFileId}
                  uploadedFiles={logoFiles}
                  setUploadedFiles={setLogoFiles}
                  isLoadingProps={isLoadingLogo}
                  setFileid={setLogoFileId}
                  setError={setLogoError}
                  count={COUNT_UPLOAD_LOGO_FILE}
                  setIsFirstLoadingFile={setIsFirstLoadingFile}
                />
              </div>
            </FormField>

            <h3>Договора:</h3>
            <p style={{ fontSize: '12px', color: '#8c8c8c', marginTop: 10, marginBottom: 20 }}>Если вы самозанятый и оказываете услуги совместно с третьим лицом, то необходимо предоставить договор услуг. Чужие услуги и товары к реализации запрещены, но возможно привлечение третьих лиц через договор.</p>

            <FormField
                titleField={configTitleFieldsOfCompany[NamesOfFieldEnum.DocumentAgreement1FileId]}
              name={NamesOfFieldEnum.DocumentAgreement1FileId}
              styleContainer={{ minHeight: 190 }}
              renderError={documentAgreement1Error}
            >
              <div>
                <UploadFile
                  id={NamesOfFieldEnum.DocumentAgreement1FileId}
                  uploadedFiles={documentAgreement1Files}
                  setUploadedFiles={setDocumentAgreement1Files}
                  isLoadingProps={isLoadingDocumentAgreement1File}
                  setFileid={setDocumentAgreement1FileId}
                  count={COUNT_DOCUMENT_AGREEMENT1_FILE}
                  setError={setDocumentAgreement1Error}
                  setIsFirstLoadingFile={setIsFirstLoadingFile}
                />
              </div>
            </FormField>


            <FormField
                titleField={configTitleFieldsOfCompany[NamesOfFieldEnum.DocumentAgreement2FileId]}
              name={NamesOfFieldEnum.DocumentAgreement2FileId}
              styleContainer={{ minHeight: 190 }}
              renderError={documentAgreement2Error}
            >
              <div>
                <UploadFile
                  id={NamesOfFieldEnum.DocumentAgreement2FileId}
                  uploadedFiles={documentAgreement2Files}
                  setUploadedFiles={setDocumentAgreement2Files}
                  isLoadingProps={isLoadingDocumentAgreement2File}
                  setFileid={setDocumentAgreement2FileId}
                  count={COUNT_DOCUMENT_AGREEMENT2_FILE}
                  setError={setDocumentAgreement2Error}
                  setIsFirstLoadingFile={setIsFirstLoadingFile}
                />
              </div>
            </FormField>
          </>
        )}
      </div>
      <RulesFiles />
      <Divider style={{ margin: 0 }} />
      <AcceptPolitics />
    </Wizard.Page>
  );
};
